module.exports = __webpack_public_path__ + "static/media/6.6a9438c5.jpeg";